import snakeCase from 'lodash/snakeCase';
import invert from 'lodash/invert';

import LayoutCommonNew from "../../visComponents/layoutCommonNew";

import Globals from "./parts/globals";

import {LayoutType, LayoutAbbreviation} from "./constants";
import zIndexes from "./zIndex";
import Other from "./parts/other";
import NonVisualizerSubPart from "./subparts/nonVisualizerSubPart";
import DesignNavigationItem from "../../visComponents/designNavigationItem";
import Background from "./parts/background";
import Appliance from "./parts/appliance";
import CountertopGroup from "./parts/countertopGroup";
import Cabinet from "./parts/cabinet";
import Floor from "./parts/floor";
import Walls from "./parts/walls";
import CenterIsland from "./parts/centerIsland";
import {AVAILABLE_VISUALIZER_TYPES} from "../../../config";

export class Layout extends LayoutCommonNew {

  /**
   * @type {int}
   */
  defaultType = LayoutType.Layout1;
  type = this.defaultType;
  scene = "1";
  visualizerType = AVAILABLE_VISUALIZER_TYPES.kvScene;
  localStorageKey = "kvSceneState";
  layersBinding = "KitchenV5";
  layoutNames = LayoutAbbreviation;
  layoutTypes = LayoutType;
  zIndexes = zIndexes.layouts;
  excludedPartIdsFromHover = ["decor_", "background_bg", "walls_ceiling", "attachment"];

  constructor(props) {
    super(props);
    this.parts[Background.id] = new Background();
    this.parts[CenterIsland.id] = new CenterIsland();
    this.parts[CountertopGroup.id] = new CountertopGroup();
    this.parts[Appliance.id] = new Appliance();
    this.parts[Cabinet.id] = new Cabinet();
    this.parts[Walls.id] = new Walls();
    this.parts[Floor.id] = new Floor();
    this.parts[Globals.id] = new Globals();
    this.parts[Other.id] = new Other();
    Object.values(this.parts).forEach(part => part.layout = this);
  }

  getCurrentLayoutName(type = this.type) {
    return invert(LayoutType)[type];
  }

  getCurrentLayoutAbbreviation() {
    return LayoutAbbreviation[this.getCurrentLayoutName()]
  }

  addNonVisualizerSubPart(featureGroupName){
    const otherParent = this.parts[Other.id];
    const partId = snakeCase(featureGroupName);
    let relatedItem = otherParent.relatedItems.find(relatedItem => relatedItem.partId === partId);
    if (!relatedItem) {
      relatedItem = new NonVisualizerSubPart(true, partId, featureGroupName);
      relatedItem.getParent = () => otherParent;
      otherParent.relatedItems.push(relatedItem);
    }
    return new DesignNavigationItem(relatedItem.partName, relatedItem)
  }

}
